"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.createBreakpoints = void 0;

var lodash_1 = require("lodash");

var defaultBreakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

exports.createBreakpoints = function (breakpoints) {
  var values = lodash_1.merge(breakpoints || {}, defaultBreakpoints);
  return __assign(__assign({}, values), {
    down: function down(size) {
      var value = typeof size === 'number' ? size : values[size];
      return "@media (max-width: " + value + "px)";
    },
    up: function up(size) {
      var value = typeof size === 'number' ? size : values[size];
      return "@media (min-width:" + value + "px)";
    }
  });
};